import moment from "moment";
import { ExerciseData } from "src/screens/ChargeProgression/interfaces";

export function getProgressionSummary(exercises: ExerciseData[]) {
  const allWeights: number[] = [];
  const allReps: number[] = [];

  exercises.forEach((exercise) => {
    exercise.data.forEach((set) => {
      allWeights.push(isNaN(set?.weight) ? 0 : set.weight);
      allReps.push(isNaN(set?.reps) ? 0 : set.reps);
    });
  });

  const calcAvgPctChange = (values: number[]) => {
    let totalPct = 0,
      count = 0;
    for (let i = 1; i < values.length; i++) {
      const prev = values[i - 1],
        curr = values[i];
      if (prev === 0) continue;
      totalPct += ((curr - prev) / prev) * 100;
      count++;
    }
    return count > 0
      ? `${totalPct >= 0 ? "+" : ""}${(totalPct / count).toFixed(1)}%`
      : "0%";
  };

  return {
    avgWeightChangePct: calcAvgPctChange(allWeights),
    avgRepsChangePct: calcAvgPctChange(allReps),
  };
}

export const formatChart = (exercises: ExerciseData[]) => {
  const categories: string[] = []; // Eixo X (dias em índice)
  const reps: number[] = []; // Série de repetições
  const weight: number[] = []; // Série de pesos
  const feedback: Array<{ date: string; message: string }> = []; // Feedback
  const dates: string[] = []; // Datas reais para a tooltip

  let dayCounter = 1; // Inicia o contador de dias

  exercises.forEach((exercise) => {
    exercise.data.forEach(() => {
      const lab = `DIA ${dayCounter}º`;
      // Adiciona o dia no formato "1º Dia", "2º Dia", etc.
      categories.push(categories.includes(lab) ? "" : lab);

      // Adiciona a data formatada para ser usada na tooltip
      dates.push(moment(exercise.exec_at).format("DD/MM/YY - HH:mm"));
    });

    // Incrementa o contador de dias após cada exercício
    dayCounter++;

    // Adiciona cada repetição e peso separadamente
    exercise.data.forEach((set) => {
      if (!set) return; //Erro do Tiago Romero: Algum aluno preencheu de forma incorreta ou o app salvou errado, gerando exceção
      reps.push(set.reps ? (isNaN(set.reps) ? 0 : set.reps) : 0);
      weight.push(set.weight ? (isNaN(set.weight) ? 0 : set.weight) : 0);
    });

    // Adiciona o feedback apenas uma vez por exercício
    if (exercise.feedback !== "")
      feedback.push({
        date: exercise.exec_at,
        message: exercise.feedback,
      });
  });

  return { categories, reps, weight, feedback, dates };
};

export function getDaySplitAnnotations(
  categories: string[],
): XAxisAnnotations[] {
  const cat = categories.filter((e) => e);
  return cat
    .filter((e) => e)
    .map(
      (x, i) =>
        ({
          x,
          borderColor: "#ff000088",
          strokeDashArray: 5,
          /*label: {
            borderColor: "#ffE39600",
            orientation: "horizontal",
            text: x.replace("DIA ", ""),
            position: "center", // <-- aqui está o ajuste importante
          },*/
        }) as XAxisAnnotations,
    )
    .filter((e) => e !== undefined);
}

export function formatFeedbackPoints(
  exercises: ExerciseData[],
  onEnter: (msg: string) => void,
  onLeave?: () => void,
): PointAnnotations[] {
  let dayCounter = 0;
  return exercises
    .map((e) => {
      dayCounter++;
      return (
        e.feedback
          ? {
              x: `DIA ${dayCounter}º`,
              y: 0,
              marker: {
                size: 10,
                fillColor: "#fff",
                strokeColor: "red",
                strokeWidth: 1.5,
                offsetY: -20,
              },
              /* image: {
                path: "https://cdn-icons-png.flaticon.com/512/1380/1380338.png", // URL do ícone do balão
                width: 15,
                height: 15,
                offsetY: -19,
              },*/
              click: () => onEnter(e.feedback),
              mouseLeave: onLeave,
            }
          : undefined
      ) as PointAnnotations;
    })
    .filter((e) => e !== undefined);
}
